const config = {
  apiKey: "AIzaSyBXRKX8mI_k9MuCwmzDV0F6HChy6Hfn9Oo",
  authDomain: "movierecommender-54254.firebaseapp.com",
  projectId: "movierecommender-54254",
  storageBucket: "movierecommender-54254.appspot.com",
  messagingSenderId: "929636781034",
  appId: "1:929636781034:web:c4234cb8ee3ad52298c093",
  measurementId: "G-R7HD321BHE",
};

export { config };
